import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../lib/site";

export const WhatsAppFloat = () => (
  <motion.a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-button"
    aria-label="Chat on WhatsApp"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
    className="fixed bottom-6 right-6 z-50 flex h-13 w-13 items-center justify-center bg-ember p-3.5 text-coal-900 transition-colors duration-300 hover:bg-white"
  >
    <MessageCircle size={22} />
  </motion.a>
);
